import React, { useEffect, useState } from "react";
import {
  Layout,
  Dropdown,
  Avatar,
  Menu,
  Input,
  Button,
  Divider,
  ConfigProvider,
} from "antd";
import { Link, useNavigate } from "react-router-dom";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  LogoutOutlined,
  UserOutlined,
} from "@ant-design/icons";
import {
  CloseOutlined,
  HomeOutlined,
  SearchOutlined,
  DownOutlined,
  EyeInvisibleOutlined,
} from "@ant-design/icons/lib/icons";
import { routes } from "../../util/constant";
import { NavLink, useLocation } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { YashLogo } from "../../assets/images";
import { fetchDetails } from "../../redux/data/dataAction";
import { useDispatch, useSelector } from "react-redux";
// import { fetchDetails } from "../redux/data/dataAction";

const { Header } = Layout;

const { Search } = Input;
export default function HeaderComponent(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const categories = useSelector((state) => state.data.categories);
  const [current, setCurrent] = useState(routes.CATALOG);
  const { instance, accounts } = useMsal();
  const [searchValue, setSearchValue] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const handleLogout = () => {
    instance.logoutRedirect().catch((e) => console.error("Logout failed", e));
  };

  // console.log("accounts:", accounts);
  const getUsername = (email) => {
    return email.split("@")[0];
  };

  const handleLinkClick = () => {
    setSearchValue("");
  };

  const handleSearch = async () => {
    if (searchValue.trim() === "") return;
    navigate("/search", {
      state: { searchValue: searchValue },
    });
    setSearchValue("");
  };
  const handleLoginRedirect = () => {
    instance.logoutRedirect();
  };
  useEffect(() => {
    setCurrent(props?.location?.pathname);
  }, [props.location.pathname]);

  function capitalizeFirstLetter(word) {
    if (!word) return word;
    return word.charAt(0).toUpperCase() + word.slice(1);
  }

  const desiredOrder = [
    "Team Charter",
    "Offerings",
    "Service Offerings",
    "Architecture",
    "Accelerators",
    "Certifications",
    "Blogs",
    "Process Document",
  ];

  const sortSubcategories = (subcategories) => {
    return [...subcategories].sort((a, b) => {
      const indexA = desiredOrder.indexOf(a.name);
      const indexB = desiredOrder.indexOf(b.name);

      if (indexA !== -1 && indexB !== -1) {
        return indexA - indexB;
      }

      if (indexA !== -1) {
        return -1;
      }

      if (indexB !== -1) {
        return 1;
      }

      return 0;
    });
  };

  // const onSearch = (value, _e, info) => {
  //   setsearchvalue("");
  //   if (searchQuery.trim() === "") return;
  //   try {
  //     const action = fetchDetails(searchQuery);
  //     const result = await dispatch(action);
  //     if (result.payload && result.payload.searchResults) {
  //       navigate("/search", {
  //         state: { searchResults: result.payload.searchResults },
  //       });
  //     } else {
  //       console.error("Error: API response does not contain searchResults");
  //     }
  //   } catch (error) {
  //     console.error("Error during search:", error);
  //   }

  // };

  const items = [
    {
      label: (
        <Link to="/" className="ms-3 me-3" style={{ textDecoration: "none" }}>
          <HomeOutlined style={{ fontSize: "16px", color: "#005BA1" }} />
          <span
            className="ms-3 me-3"
            style={{ paddingLeft: "2px", fontSize: "14px" }}
          >
            Home
          </span>
        </Link>
      ),
      key: "0",
    },
    {
      label: (
        <span className="ms-3 fs-3" onClick={handleLogout}>
          <LogoutOutlined style={{ fontSize: "14px", color: "red" }} />
          <span
            className="ms-3 me-3"
            style={{ paddingLeft: "2px", fontSize: "14px" }}
          >
            Sign Out
          </span>
        </span>
      ),
      key: "1",
    },
  ];

  const handleimgClick = () => {
    navigate("/");
  };
  const handleCategoryClick = (category) => {
    if (category.toLowerCase() === "solutions") {
      window.open("https://devxops.solutions.yashtech.link/", "_blank");
      return;
    }
  };

  return (
    <Header
      className="flex items-center bg-white fixed w-full h-[68px] leading-5 z-1"
      style={{
        display: "flex",
        justifyContent: "space-between",
        padding: "0px 10px 0 25px",
      }}
    >
      <div className="flex items-center">
        <div>
          <img
            src={YashLogo}
            alt="YashLogo"
            className="md:h-[42px]"
            style={{ left: "22px", height: "42px" }}
            onClick={handleimgClick}
          />
        </div>

        <div>
          <Menu
            selectable={false}
            className="custom-navigation-menu flex space-x-5 text-gray-600 remove-menu-hover"
            mode="horizontal"
            style={{
              height: "30px",
              marginTop: "10px",
              borderBottom: "none",
              fontSize: "1rem",
              fontWeight: "500",
              flex: 1,
              marginLeft: "35px",
              display: "flex",
            }}
          >
            {Object.keys(categories).map((category, index) => {
              if (category.toLowerCase() === "solutions") {
                return (
                  <Menu.Item
                    key={category}
                    onClick={() => handleCategoryClick(category)}
                    className="submenu-item"
                  >
                    {capitalizeFirstLetter(category)}
                  </Menu.Item>
                );
              }
              const sortedSubcategories = sortSubcategories(
                categories[category]?.subcategories || []
              );
              return (
                <Menu.SubMenu
                  className="submenu-item"
                  title={capitalizeFirstLetter(category)}
                  key={category}
                >
                  {sortedSubcategories.map((subcategory, i) => (
                    <Menu.Item
                      key={`${category}-${subcategory.name}`}
                      onClick={() =>
                        navigate(`/node/${category}/${subcategory.name}`)
                      }
                      style={{ width: "auto" }}
                      className="text-base"
                    >
                      {subcategory.name}
                    </Menu.Item>
                  ))}
                </Menu.SubMenu>
              );
            })}
          </Menu>
        </div>
      </div>

      <div className="flex justify-between items-center mr-6">
        <div style={{ color: "#005BA1", margin: "0 20px 0 0", width: "270px" }}>
          <Input
            size="middle"
            style={{ borderRadius: "16px" }}
            suffix={
              <SearchOutlined style={{ fontSize: "large", color: "#8A8A8A" }} />
            }
            value={searchValue}
            allowClear
            onChange={(e) => {
              setSearchValue(e.target.value);
            }}
            onPressEnter={handleSearch}
            // size="large"
            placeholder="Search document..."
            // onSearch={handleSearch}
            enterButton={<SearchOutlined />}
          />
        </div>
        <div>
          <Divider
            type="vertical"
            style={{
              height: "55px",
              border: "0.01px solid rgb(224 224 224 / 45%)",
            }}
          />
        </div>
        <div className="pl-4">
          <div className="flex" onClick={(e) => e.preventDefault()}>
            {/* <div className=""> */}
            <div className="avatar-img mt-2">
              <Avatar
                style={{
                  backgroundColor: "#005BA1",
                }}
                size={40}
                icon={<UserOutlined />}
              />
            </div>
            <Dropdown
              menu={{
                items,
              }}
              overlayStyle={{ margin: "15px -20px 0 0px" }}
              trigger={["click"]}
              placement="bottomRight"
            >
              <div className="flex mb-2">
                {accounts[0]?.username.startsWith("hh") ? (
                  <div style={{ margin: "8px -30px 0px 5px" }}>
                    {accounts.length > 0 && (
                      <div className="font-bold font-sans text-xs mb-2">
                        {getUsername(accounts[0]?.username)
                          .split(".")
                          .map((word) => capitalizeFirstLetter(word) + " ")}
                      </div>
                    )}
                    <div className="font-bold font-sans text-xs text-gray-400	mt-1">
                      Admin
                    </div>
                  </div>
                ) : (
                  <div style={{ margin: "16px -30px 0px 5px" }}>
                    {accounts.length > 0 && (
                      <>
                        <div className="font-bold font-sans text-xs mb-2 ">
                          {getUsername(accounts[0]?.username)
                            .split(".")
                            .map((word) => capitalizeFirstLetter(word) + " ")}
                        </div>
                      </>
                    )}
                  </div>
                )}
                <DownOutlined style={{ margin: "10px -25px 0px 40px" }} />
              </div>
            </Dropdown>
          </div>
        </div>
      </div>
    </Header>
  );
}
